export type RewardBonusDisplay =
  | { mode: "plain" }
  | {
      mode: "entity";
      bonusId: number;
      title: string;
      image?: string;
    }
  | {
      mode: "fallback";
      bonusId: number;
      label: string;
    };

export type RewardBonusSource = {
  compensationType?: string | null;
  bonusId?: string | number | null;
  bonusTitle?: string | null;
  bonusImage?: string | null;
};

const REWARD_TYPE = "reward";
const INT32_MAX = 2147483647;

export const normalizeLinkedBonusId = (
  value: string | number | null | undefined,
): number | null => {
  if (typeof value === "number") {
    return Number.isInteger(value) && value > 0 && value <= INT32_MAX
      ? value
      : null;
  }

  if (typeof value !== "string") {
    return null;
  }

  const trimmed = value.trim();
  if (!/^[0-9]+$/.test(trimmed)) {
    return null;
  }

  const id = Number(trimmed);
  return Number.isInteger(id) && id > 0 && id <= INT32_MAX ? id : null;
};

export const resolveRewardBonusDisplay = (
  item: RewardBonusSource,
): RewardBonusDisplay => {
  const bonusId = normalizeLinkedBonusId(item.bonusId);
  const isReward =
    typeof item.compensationType === "string" &&
    item.compensationType.trim().toLowerCase() === REWARD_TYPE;

  if (!isReward || bonusId == null) {
    return { mode: "plain" };
  }

  const title = typeof item.bonusTitle === "string" ? item.bonusTitle.trim() : "";
  if (!title) {
    return {
      mode: "fallback",
      bonusId,
      label: `Bonus #${bonusId}`,
    };
  }

  const image = typeof item.bonusImage === "string" ? item.bonusImage.trim() : "";

  return {
    mode: "entity",
    bonusId,
    title,
    ...(image ? { image } : {}),
  };
};
